module.exports = __webpack_public_path__ + "static/media/event-image.e2af2b08.jpg";